// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tyAy","icon":"styles_icon__1yIbA"};